import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import { Reveal } from "./Reveal";
import { CONTACT, GALLERY_ITEMS } from "../data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const InstagramFeed = () => {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    fetch(`${API}/instagram/posts`)
      .then((r) => r.json())
      .then((body) => setPosts(body.configured && body.data?.length ? body.data : []))
      .catch(() => setPosts([]));
  }, []);

  const fallbackTiles = GALLERY_ITEMS.slice(0, 6);

  return (
    <section data-testid="instagram-section" className="border-t hairline bg-ink py-20 sm:py-24">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between">
            <div>
              <p className="eyebrow mb-4">@albesi_axh_metal</p>
              <h2 data-testid="instagram-title" className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
                Na ndiqni në Instagram
              </h2>
            </div>
            <a
              href={CONTACT.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="instagram-follow-button"
              className="inline-flex items-center gap-3 border border-white/20 px-6 py-3 font-display text-xs font-semibold uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:border-bronze hover:text-bronze"
            >
              <Instagram size={16} />
              Ndiqni profilin
            </a>
          </div>
        </Reveal>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-testid="instagram-grid">
          {(posts === null ? [] : posts.length ? posts : fallbackTiles).map((item, i) => {
            const isPost = Boolean(item.permalink);
            const src = isPost ? (item.media_type === "VIDEO" ? item.thumbnail_url : item.media_url) : item.src;
            const href = isPost ? item.permalink : CONTACT.instagram;
            const alt = isPost ? (item.caption || "Postim në Instagram").slice(0, 120) : item.title;
            return (
              <Reveal key={isPost ? item.id : item.src} delay={Math.min(i * 0.05, 0.25)}>
                <a
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`instagram-item-${i}`}
                  className="group relative block overflow-hidden"
                >
                  <img
                    src={src}
                    alt={alt}
                    loading="lazy"
                    className="aspect-square w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 flex items-center justify-center bg-ink/60 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                    <Instagram size={22} className="text-bronze" />
                  </div>
                </a>
              </Reveal>
            );
          })}
          {posts === null &&
            [...Array(6)].map((_, i) => (
              <div key={i} className="aspect-square w-full animate-pulse bg-elevated" data-testid={`instagram-skeleton-${i}`} />
            ))}
        </div>
      </div>
    </section>
  );
};
